import type { Currency } from '../domain/enums';
import { groupThousands, MINUS, NBSP } from './number';

export const CURRENCY_SYMBOL: Record<Currency, string> = {
  USD: '$',
  EUR: '€',
  UAH: 'грн',
};

/** 18900, USD → "18 900 $"; 148000, UAH → "148 000 грн". Amounts are whole currency units. */
export function formatMoney(amount: number, currency: Currency): string {
  const sign = amount < 0 ? MINUS : '';
  return `${sign}${groupThousands(amount)}${NBSP}${CURRENCY_SYMBOL[currency]}`;
}

/** Always shows the sign: +20 500 $, −1 750 €, 0 $. Used for margins. */
export function formatSignedMoney(amount: number, currency: Currency): string {
  if (amount > 0) return `+${formatMoney(amount, currency)}`;
  return formatMoney(amount, currency);
}
